<template>

<div>

   <div class="section bg-world px-0 lg:px-1">

     <div class="mb-8">
       <Navbar />
     </div>

     <div class=" ">
       <div class="hero-text w-row">
         <div class="w-col w-col-6 font-sharp">
           <h1 class="heading hidden lg:block text-red-200">Hashkittens</h1>
           <div class="text-block-11 mt-20 lg:mt-0">Mine ⛏️ Build 🧶 Trade 🐈 Meoww </div>
         </div>
       </div>
       <div class="div-block">
        
         <a href="https://etherscan.io/address/0x0a59f69075b0c17a57c208471d0adb99ff368471#code" target="_blank" class="button1-base w-inline-block">
           <div>Etherscan Contract Code</div>
         </a>
        
         
       </div>
     </div>
   </div>

   <div class="section autospacing">
     <div class="w-container">
       <div class="w-row">
         <div class="w-col w-col-6 mt-4">
           <div class="w-col w-col-6">
         
           <img src="@/assets/images/hashkitten.png"></img>

             <div class="paragraph-2">
             
               <a href="https://discord.gg/wgst7qM5n3" target="_blank">
            <div class="bg-purple-600 hover:bg-purple-700 text-white p-4 rounded"> <img src="@/assets/images/discord-icon.svg" width="40" height="40" alt=""> <div class="text-md text-white inline pl-2">  Join Discord</div></div>
          </a>
              
              </div>
         </div>
         </div>
         <div class="w-col w-col-6">
           
           <img src="@/assets/images/mine_hk.gif"></img>
         </div>
       </div>
     </div>
   </div>


  


   <div class="section">


    <Carousel />



   </div>

  
   <div class="section autospacing testimonial">
     <div class="w-container">
       <div class="quote">
         <p class="paragraph-4">&quot;... Meow meow, meow meow meow meow ... MEOW! ...&quot;</p>
         <div class="text-block-4">- Ser Meowingtons, The Curious Feline&#x27;s Handbook - <a href=""  class="text-link">Read his full report</a></div>
       </div>
     </div>
   </div>

  <Footer/>

</div>
</template>


<script>
import Navbar from './components/Navbar.vue';
import Carousel from './components/Carousel.vue';
import Footer from './components/Footer.vue';

import {resolveRestQuery} from '../js/rest-api-helper'

export default {
  name: 'Home',
  props: [],
  components: {Navbar,Carousel,Footer},
  data() {
    return {
      latestBlockData: null
    }
  },

  created(){

    this.fetchLatestBlockData()

    setInterval( this.fetchLatestBlockData.bind(this) , 60 * 1000 )
  },
  methods: {
    async fetchLatestBlockData(){

      let baseURI = 'https://api.0xbtc.io/api/mints'
      let result = await resolveRestQuery(`${baseURI}`,{contractAddress:"0xb6ed7644c69416d67b522e20bc294a9a9b405b31"})
        

      if(result && result.success){
        this.latestBlockData = result.output[0]
      }

    },

    getCurrentHashrate(){

      let rawHashrate = this.latestBlockData.hashrate_avg8mint

      return ( rawHashrate / 1000000000000 ).toFixed(2)
    }
  },


}
</script>
